import React from 'react'
import { get } from 'lodash'
import { gql, useQuery } from '@apollo/client'
import { Link } from 'react-router-dom'

import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import InfoOutlinedIcon from 'components/material-symbol/icons/Info'
import LibraryBooksIcon from 'components/material-symbol/icons/LibraryBooks'
import TipWell, { TipWellActionButton } from 'components/tip-well'

import ActionTile from 'components/action-tile'
import BookingTypesView from '../booking-types/booking-types-view'
import GroupEventsPanel from '../events/group-events-panel'
import { useStyles } from './styles'
import { OFFERINGS_TAB } from './routes'

const GET_AVAILABILITY = gql`
  query CoachAvailability {
    coachAvailabilities {
      coachFacility {
        id
        name
      }
      startDate
      timeZone
      timeSlots {
        day
        startTime
        endTime
      }
    }
  }
`

const OfferingsPage = ({
  selectedTab,
  hasCoachProfile,
  setShouldShowBookingTypeDisclaimer,
  groupEventsPanel,
}) => {
  const { data, loading } = useQuery(GET_AVAILABILITY)
  const classes = useStyles()
  const availabilities = get(data, 'coachAvailabilities', [])
  const showSetAvailabilityTooltip =
    selectedTab === OFFERINGS_TAB.BOOKING_TYPE &&
    !loading &&
    !availabilities?.some(a => a.timeSlots.length > 0)

  const bookingTypeContent = (() => {
    if (hasCoachProfile) {
      return (
        <Grid container>
          <BookingTypesView
            setShouldShowDisclaimer={setShouldShowBookingTypeDisclaimer}
          />
        </Grid>
      )
    }

    return (
      <ActionTile
        className={classes.disabledActionTile}
        icon={LibraryBooksIcon}
        headlineText="Booking Type"
        captionText="Before publishing your booking type, please make sure you have **first created your Coach Profile**."
        callToAction={
          <Button
            component={Link}
            to="/pga-coach/profile"
            variant="contained"
            color="primary"
            data-cy="see-coach-booking-types"
          >
            Go To Coach Profile
          </Button>
        }
      />
    )
  })()

  return (
    <Container maxWidth={false} disableGutters className={classes.root}>
      {showSetAvailabilityTooltip ? (
        <Box className={classes.tipBannerWrapper}>
          <TipWell
            icon={InfoOutlinedIcon}
            caption="Set your availability at each location before creating coach offerings."
            action={
              <TipWellActionButton
                component={Link}
                to="/pga-coach/settings/availability"
              >
                Set Availability
              </TipWellActionButton>
            }
          />
        </Box>
      ) : null}
      {selectedTab === OFFERINGS_TAB.BOOKING_TYPE ? (
        <Box className={classes.tabContent}>{bookingTypeContent}</Box>
      ) : (
        <Box className={`${classes.groupEventsWrapper} ${classes.tabContent}`}>
          <GroupEventsPanel panel={groupEventsPanel} showInlineTabs />
        </Box>
      )}
    </Container>
  )
}

export { OFFERINGS_TAB, getOfferingsPath, parseOfferingsTab } from './routes'
export default OfferingsPage
